import { useT } from "@/i18n/LanguageContext";

export default function CrossSection() {
  const { t } = useT();
  return (
    <section
      id="layers"
      data-testid="layers-section"
      className="relative bg-[#0A0A0A] border-b border-white/10"
    >
      <div className="grid grid-cols-12 border-b border-white/10">
        <div className="col-span-12 md:col-span-3 border-r border-white/10 px-6 sm:px-8 py-10 md:py-20">
          <p className="text-[10px] uppercase tracking-[0.3em] text-white/50">
            {t.layers.label}
          </p>
        </div>
        <div className="col-span-12 md:col-span-9 px-6 sm:px-10 py-10 md:py-20">
          <h2
            data-testid="layers-headline"
            className="font-display font-bold uppercase tracking-tighter text-white text-4xl sm:text-5xl lg:text-6xl leading-[0.95] max-w-3xl"
          >
            {t.layers.title}
          </h2>
          <p className="mt-6 text-base text-white/70 max-w-xl">{t.layers.intro}</p>
        </div>
      </div>

      <div className="grid grid-cols-12">
        {/* Visual stack — 5 layers + sandwich repeat 04, 03, 02 below for symmetry */}
        <div className="col-span-12 md:col-span-5 border-r border-white/10 px-6 sm:px-10 py-12 md:py-20 flex items-center justify-center min-h-[460px]">
          <div className="relative w-full max-w-[360px] aspect-[3/4]" aria-hidden>
            {[
              { c: "#E8E8E8", w: "100%", top: "5%",  lbl: "01" },
              { c: "#3A3F45", w: "94%", top: "16%", lbl: "02" },
              { c: "#9A9A9A", w: "92%", top: "27%", lbl: "03" },
              { c: "#5A4030", w: "90%", top: "38%", lbl: "04" },
              { c: "#C9A36B", w: "88%", top: "49%", lbl: "05" },
              { c: "#5A4030", w: "90%", top: "60%", lbl: "04" },
              { c: "#9A9A9A", w: "92%", top: "71%", lbl: "03" },
              { c: "#3A3F45", w: "94%", top: "82%", lbl: "02" },
            ].map((s, i) => (
              <div
                key={i}
                className="absolute left-1/2 -translate-x-1/2 h-[8.5%] border border-white/10 shadow-[0_8px_24px_rgba(0,0,0,0.35)]"
                style={{
                  top: s.top,
                  width: s.w,
                  background: s.c,
                  transform: "translateX(-50%) skewY(-8deg)",
                }}
              >
                <span className="absolute -left-10 top-1/2 -translate-y-1/2 text-[10px] tracking-[0.25em] text-white/50">
                  {s.lbl}
                </span>
              </div>
            ))}
          </div>
        </div>

        {/* List */}
        <ol className="col-span-12 md:col-span-7">
          {t.layers.items.map((item, i) => (
            <li
              key={item.n}
              data-testid={`layer-row-${item.n}`}
              className={`grid grid-cols-12 ${
                i !== t.layers.items.length - 1 ? "border-b" : ""
              } border-white/10 hover:bg-white/[0.03] transition-colors`}
            >
              <div className="col-span-2 md:col-span-2 px-6 py-6 font-display text-2xl text-white/40">
                {item.n}
              </div>
              <div className="col-span-10 md:col-span-4 px-2 md:px-6 py-6 font-display text-base md:text-lg uppercase tracking-tight text-white">
                {item.name}
              </div>
              <div className="col-span-12 md:col-span-6 px-6 pb-6 md:py-6 text-sm text-white/60">
                {item.desc}
              </div>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}
